
import { DropdownModel } from 'lib/ng2-sapmp/src/ui-components/dropdown';

export class LicensesBackInitModel {
  fanNumbers: Array<DropdownModel>;
  banNumbers: Array<DropdownModel>;
  ctnNumbers: Array<string>;
  showFan: string;
  selectedFan: DropdownModel;
  selectedBan: DropdownModel;
  selectedCtn: string;
  increaseQty: string;

  constructor() {
      this.fanNumbers = undefined;
      this.banNumbers = undefined;
      this.ctnNumbers = undefined;
      this.selectedCtn = undefined;
      this.increaseQty = undefined;
  }
}
